import styled from 'styled-components';
import { tokens } from '@cellula/react-theme-patient';
import { NEW_MESSAGES_BANNER_ID } from './_constants';
import { withTranslation } from '@application/i18n/with_translation';
import { forwardRef, Ref } from 'react';
import { Text } from '@cellula/react';

interface Props {}

const elements = {
	container: styled.div`
		display: flex;
		align-items: center;
		padding: 0 ${tokens.spacing.x2};
		font: ${tokens.text.label.smallRegular};
		color: ${tokens.color.content.interactive};
		margin-top: ${tokens.spacing.x2};

		${tokens.breakpointQuery.medium} {
			padding: 0 ${tokens.spacing.x4};
		}

		span {
			padding: 0 ${tokens.spacing.x0_5};
		}

		&::before,
		&::after {
			content: '';
			display: flex;
			background: ${tokens.color.content.interactive};
			height: 1px;
			flex: 1;
		}
	`,
};

function _NewMessagesBanner(props: Props, ref: Ref<HTMLDivElement>): JSX.Element {
	return (
		<elements.container ref={ref} id={NEW_MESSAGES_BANNER_ID} {...props}>
			<Text variant='bodySmallRegular'>{withTranslation('PW.Component.Chat.Banner.NewMessages')}</Text>
		</elements.container>
	);
}
export const NewMessagesBanner = forwardRef(_NewMessagesBanner);
